import {observable} from "mobx";

import api from "../Services/Api";
import {Order} from "../Entities/Order/Order";


// сервер валидирует Page как [Range(0, MaxPage)] - страницы дальше запрашивать нельзя
const maxPage = 100;
const maxMarketplaceIdLength = 50;

class OrderListStore {
    @observable orders: Order[] = [];
    @observable loading: boolean = false;
    @observable error: string | null = null;
    @observable page: number = 0;
    @observable totalCount: number = 0;
    @observable dateFrom?: Date;
    @observable dateTo?: Date;
    @observable marketplaceId: string = "";
    itemsPerPage: number = 30;
    private requestId: number = 0;

    get pagesCount(): number {
        return Math.min(Math.ceil(this.totalCount / this.itemsPerPage), maxPage + 1);
    }

    public async init() {
        this.page = 0;
        this.dateFrom = undefined;
        this.dateTo = undefined;
        this.marketplaceId = "";
        await this.load();
    }
    
    private async load(){
        const requestId = ++this.requestId;
        this.loading = true;
        
        try {
            const result = await api.post("order/list", {
                page: this.page,
                itemsPerPage: this.itemsPerPage,
                dateFrom: this.dateFrom?.toISOString(),
                dateTo: this.dateTo?.toISOString(),
                marketplaceId: this.marketplaceId || undefined,
            });
            // ответ устаревшего запроса не должен перетирать более свежий
            if(requestId !== this.requestId) {
                return;
            }
            if(result.success) {
                this.orders = result.data.orders;
                this.totalCount = result.data.totalCount;
            }
        }
        finally {
            if(requestId === this.requestId) {
                this.loading = false;
            }
        }
    }

    public search() {
        this.page = 0;
        void this.load();
    }
    
    public setPage(page: number) {
        this.page = page;
        void this.load();
    }

    public setMarketplaceId(marketplaceId: string) {
        this.marketplaceId = marketplaceId.slice(0, maxMarketplaceIdLength);
    }

    public setDateFrom(date? : Date) {
        this.dateFrom = date;
        this.search();
    }

    public setDateTo(date? : Date) {
        this.dateTo = date;
        this.search();
    }
}

const orderListStore = new OrderListStore();

export default orderListStore;